import type { Unit, UnitTargetable } from 'effector'

import {
  attach,
  createEffect,
  createEvent,
  createStore,
  sample,
} from 'effector'

export function holdup({
  target,
  cancel,
}: {
  target: UnitTargetable<void>
  cancel?: Unit<any> | Unit<any>[]
}) {
  const clock = createEvent<number>()

  const saveCancel = createEvent<[ReturnType<typeof setTimeout>, () => void]>()
  const $cancel = createStore<[ReturnType<typeof setTimeout>, () => void] | []>(
    []
  ).on(saveCancel, (_, payload) => payload)

  const cancelFx = attach({
    source: $cancel,
    effect([timeoutId, rejectPromise]) {
      if (timeoutId) clearTimeout(timeoutId)
      if (rejectPromise) rejectPromise()
    },
  })

  const timeoutFx = createEffect(
    (timeout: number) =>
      new Promise((resolve, reject) =>
        saveCancel([setTimeout(resolve, timeout), reject])
      )
  )

  $cancel.reset(timeoutFx.done, cancelFx.done)

  if (cancel) {
    sample({
      clock: cancel as Unit<any>,
      target: cancelFx,
    })
  }

  sample({
    clock,
    target: [cancelFx, timeoutFx],
  })

  sample({
    clock: timeoutFx.done,
    target,
  })

  return clock
}
